import { render, staticRenderFns } from "./jynqxj.vue?vue&type=template&id=3bcf6403&scoped=true"
import script from "./jynqxj.vue?vue&type=script&lang=js"
export * from "./jynqxj.vue?vue&type=script&lang=js"
import style0 from "./jynqxj.vue?vue&type=style&index=0&id=3bcf6403&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcf6403",
  null
  
)

export default component.exports